import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { ScrollToTop } from "@/components/ScrollToTop";
import Landing from "@/pages/Landing";
import Intake from "@/pages/Intake";
import Teaser from "@/pages/Teaser";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Report from "@/pages/Report";
import TaxExplorer from "@/pages/TaxExplorer";
import Match from "@/pages/Match";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/check" element={<Intake />} />
          <Route path="/teaser" element={<Teaser />} />
          <Route path="/report/success" element={<CheckoutSuccess />} />
          <Route path="/report/:id" element={<Report />} />
          <Route path="/tax" element={<TaxExplorer />} />
          <Route path="/match" element={<Match />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/admin" element={<Admin />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
